import React from "react";
import { ServiceTypeFormValues } from "../../types/ServiceTypeFormValues";
import { Span } from "../Span";
import { Flex } from "../Flex";
import { Box } from "../Box";
import { Field } from "formik";
import { FormikRadioButtonDescriptive } from "../FormikRadioButtonDescriptive";
import { CantFindWhatYouAreLookingFor } from "../CantFindWhatYouAreLookingFor";

interface Props {
  values: ServiceTypeFormValues;
  onServiceTypeSelected: () => void;
}

export const ServiceTypeGas: React.FC<Props> = ({
  values,
  onServiceTypeSelected,
}) => {
  const handleOnServiceTypeSelected = () => {
    onServiceTypeSelected();
  };

  return (
    <>
      <Span
        display="inline-block"
        fontSize={4}
        lineHeight={4}
        fontWeight="medium"
        mt={7}
        mb={5}
      >
        Select a service type.
      </Span>

      <Flex flexDirection="column" justifyContent="space-between">
        <Box mb={3}>
          <Field
            id="gasDisconnection"
            name="gasServiceType"
            label="Disconnection (Permanent)"
            value="gasDisconnection"
            description={
              "Request a permanent gas disconnection from your retailer when you demolish or relocate a building, complete major renovations " +
              "near the gas service, or want to remove gas from your property. Only request this service from Vector if you don’t know your gas retailer."
            }
            currentValue={values.gasServiceType}
            flexGrow={1}
            onClick={handleOnServiceTypeSelected}
            component={FormikRadioButtonDescriptive}
          />
        </Box>

        <Box mb={7}>
          <Field
            id="referenceMaps"
            name="gasServiceType"
            label="Reference maps"
            value="referenceMaps"
            description={
              "Request reference maps indicating the approximate location of our underground electricity," +
              "gas and fibre cables and pipes."
            }
            currentValue={values.gasServiceType}
            flexGrow={1}
            onClick={handleOnServiceTypeSelected}
            component={FormikRadioButtonDescriptive}
          />
        </Box>

        <CantFindWhatYouAreLookingFor serviceType={values.service} />
      </Flex>
    </>
  );
};
